import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import SavedJobItem from './SavedJobItem';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    jobList: {
        display: 'grid',
        gap: theme.spacing(2),
    },
    emptyMessage: {
        textAlign: 'center',
        marginTop: theme.spacing(4),
    },
    link: {
        textDecoration: 'none',
        color: 'inherit',
        display: 'block',
    },
}));

export default function SavedJobList({ savedJobList, onClickDelete, applied = false }) {
    const classes = useStyles();

    if (!savedJobList || savedJobList.length === 0) {
        return (
            <Typography variant="body1" className={classes.emptyMessage}>
                {applied ? '応募済みの求人はありません。' : '保存済みの求人はありません。'}
            </Typography>
        );
    }

    return (
        <Box className={classes.root}>
            <Box className={classes.jobList}>
                {savedJobList.map(savedJob => (
                    <Link
                        key={savedJob._id}
                        to={`/jobs/${savedJob.job}`}
                        className={classes.link}
                    >
                        <SavedJobItem
                            savedJob={savedJob}
                            onDelete={onClickDelete}
                        />
                    </Link>
                ))}
            </Box>
        </Box>
    );
}

SavedJobList.propTypes = {
    savedJobList: PropTypes.array,
    applied: PropTypes.bool,
    onClickDelete: PropTypes.func
};
